import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { mapOrderStatus } from '../constants'
import classes from './OrderStatusCell.module.scss'

export const OrderStatusCell = ({ val }) => {
  return (
    <Element
      elementName="span"
      className={classes.container}
      style={{
        backgroundColor: mapOrderStatus[val]?.color,
        color: '#FFFFFF',
      }}
    >
      <Translate
        value={'userManagement.orderManagement.' + mapOrderStatus[val]?.title}
      />
    </Element>
  )
}
